<script>
  export let label;
  export let classification;
  export let value;

  $: valueClasses = `w-12 h-12 flex items-center justify-center rounded-3xl ${getBackgroundColor(value)}`;

  function getBackgroundColor(v) {
    const colors = [
      "bg-[#E52E00]", "bg-[#E06316]", "bg-[#E86618]", "bg-[#F9AB47]",
      "bg-[#F9AC48]", "bg-[#FFDE69]", "bg-[#F9BD48]", "bg-[#DAC718]",
      "bg-[#D9D117]", "bg-[#3EDB45]"
    ]

    return colors[Math.min(colors.length - 1, Math.floor(v / colors.length))];
  }
</script>


<div class="w-[311px] flex items-center justify-between py-4 border-b md:border-0 lg:border-b border-neutral-300 last:border-0">
  <div>
    <div class="text-xs font-normal text-neutral-900">
      {label}
    </div>
    <div class="text-lg font-medium text-neutral-1200">
      {classification}
    </div>
  </div>

  <div class={valueClasses}>
    {value}
  </div>
</div>
